import { Badge, Box, Group, Text } from '@mantine/core';
import type { FC } from 'react';
import { Link } from 'react-router';

interface SubMenuItemProps {
  label: string;
  isActive: boolean;
  to: string;
  noOfItems?: number;
  isLoading: boolean;
}

const getBadgeColor = (isActive: boolean, isLoading: boolean) => {
  if (isLoading) {
    return 'gray.1';
  }

  if (isActive) {
    return 'grape.5';
  }

  return 'grape.3';
};

export const SubMenuItem: FC<SubMenuItemProps> = ({ label, isActive, to, noOfItems, isLoading }) => (
  <Link style={{ textDecoration: 'none' }} to={to}>
    <Group align="flex-start" gap="xxxs">
      {/* The underline sits under the label only, not under the count badge. */}
      <Box
        pb={6}
        style={{
          borderBottom: `3px solid ${isActive ? 'var(--mantine-color-grape-5)' : 'transparent'}`,
        }}
      >
        <Text c={isActive ? 'gray.9' : 'gray.6'} fw={isActive ? 600 : 400} size="xs">
          {label}
        </Text>
      </Box>

      <Badge color={getBadgeColor(isActive, isLoading)} variant="light">
        {noOfItems ?? '--'}
      </Badge>
    </Group>
  </Link>
);
